import { Skeleton } from '@/_components';

export function Loading() {
  return (
    <div className="flex flex-col">
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="flex items-center gap-3 border-b border-gray-200 py-2 dark:border-gray-700">
          {/* Avatar Skeleton */}
          <Skeleton className="size-10 shrink-0 rounded-md" />

          <div className="flex w-full flex-col gap-3">
            <div className="flex w-full items-center justify-between gap-2">
              <div className="min-w-0 flex-1 gap-1">
                {/* Name Skeleton */}
                <Skeleton className="h-4 w-28" />

                {/* SKU Skeleton */}
                <Skeleton className="mt-1 h-2.5 w-16" />
              </div>

              {/* Stock Values Skeleton */}
              <div className="flex items-center gap-4">
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-3 w-12" />
                  <Skeleton className="h-2.5 w-8" />
                </div>
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-3 w-12" />
                  <Skeleton className="h-2.5 w-8" />
                </div>
              </div>
            </div>

            <div className="flex flex-col items-start gap-1">
              {/* Stock Level Bar Skeleton */}
              <Skeleton className="h-[4px] w-full rounded-md" />
              <Skeleton className="h-2 w-12" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
